export const options = {
  orientation: 'horizontal',
  
  controls:[{
    type:'layoutContainer',
    style: {
      normal: {
        top:0,right:0,bottom:0,left:0, width:'auto',height:'auto',overflow:'hidden', transition:'none', transitionDuration:0
      },
    },
  },
  {
    type:'splitter',
    value:100
  },
  {
    type:'layoutContainer',
    style: {
      normal: {
        top:0,right:0,bottom:0,left:0, width:'auto',height:'auto',overflow:'hidden', transition:'none', transitionDuration:0
      },
    },
  },
  ],
  style:{
    normal:{
      width:300,
      height:200
    }
  }
};

export const overrideOptions = {
  controls:[{
    type:'layoutContainer',
    style: {
      normal: {
        top:0,right:0,bottom:0,left:0, width:'auto',height:'auto'
      },
    },
  },
  {
    type:'splitter',
  },
  {
    type:'layoutContainer',
    style: {
      normal: {
        top:0,right:0,bottom:0,left:0, width:'auto',height:'auto'
      },
    },
  },
  ]
};
